import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import {
  IDataSourceRequest,
  IDataSourceResult,
  StatisticSearchCriteria,
  AnalyticsChart,
} from '../models';
import { HttpParams } from '@angular/common/http';
import { HelperService } from './helper.service';

@Injectable({ providedIn: 'root' })
export class DashboardService {
  url = '/dashboards';
  request: StatisticSearchCriteria;

  constructor(private apiService: ApiService, private helperService: HelperService) {
    this.request = Object.assign({}, this.helperService.request);
  }

  getEmployeeCount(): Observable<number> {
    return this.apiService
      .post(`${this.url}/get-employees-count`, this.request)
      .pipe(map(data => data.data));
  }

  getWorkerCount(): Observable<number> {
    return this.apiService
      .post(`${this.url}/get-workers-count`, this.request)
      .pipe(map(data => data.data));
  }

  getLateInvoicesCount(): Observable<number> {
    return this.apiService
      .post(`${this.url}/get-late-invoices-count`, this.request)
      .pipe(map(data => data.data));
  }

  getNormalInvoicesCount(): Observable<number> {
    return this.apiService
      .post(`${this.url}/get-normal-invoices-count`, this.request)
      .pipe(map(data => data.data));
  }

  getInvoicesAmount(): Observable<number> {
    return this.apiService
      .post(`${this.url}/get-invoices-amount`, this.request)
      .pipe(map(data => data.data));
  }

  getInvoicesTaxAmount(): Observable<number> {
    return this.apiService
      .post(`${this.url}/get-invoices-tax-amount`, this.request)
      .pipe(map(data => data.data));
  }

  getRevenueByLocation(): Observable<AnalyticsChart[]> {
    return this.apiService
      .post(`${this.url}/get-revenue-by-location`, this.request)
      .pipe(map(data => data.data));
  }
}
